var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 7,
    viewBox: "0 0 15 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91797 7C2.12597 7 0.667969 5.542 0.667969 3.75C0.667969 1.958 2.12597 0.5 3.91797 0.5C5.70997 0.5 7.16797 1.958 7.16797 3.75C7.16797 5.542 5.70997 7 3.91797 7ZM3.91797 1.5833C2.72327 1.5833 1.75127 2.5553 1.75127 3.75C1.75127 4.9447 2.72327 5.9167 3.91797 5.9167C5.11267 5.9167 6.08467 4.9447 6.08467 3.75C6.08467 2.5553 5.11267 1.5833 3.91797 1.5833ZM11.418 7C9.62597 7 8.16797 5.542 8.16797 3.75C8.16797 1.958 9.62597 0.5 11.418 0.5C13.21 0.5 14.668 1.958 14.668 3.75C14.668 5.542 13.21 7 11.418 7ZM11.418 1.5833C10.2233 1.5833 9.25127 2.5553 9.25127 3.75C9.25127 4.9447 10.2233 5.9167 11.418 5.9167C12.6127 5.9167 13.5847 4.9447 13.5847 3.75C13.5847 2.5553 12.6127 1.5833 11.418 1.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlicker);
export default __webpack_public_path__ + "static/media/flicker.00a26c02e64cb9da2d5ef4b0cadab0d0.svg";
export { ForwardRef as ReactComponent };